import { render } from "./IconBox.vue?vue&type=template&id=14d1e0cf"
import script from "./IconBox.vue?vue&type=script&lang=js"
export * from "./IconBox.vue?vue&type=script&lang=js"

import "./IconBox.vue?vue&type=style&index=0&id=14d1e0cf&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__